import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_SwiperJS = _resolveComponent("SwiperJS")!

  return (_openBlock(), _createBlock(_component_SwiperJS, _mergeProps(_ctx.swiperOptions, _toHandlers(_ctx.eventHandlers)), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.showDummySlideForMiscalculatedSlidesPerGroup)
        ? (_openBlock(), _createBlock(_component_SwiperSlide, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.swiperOptions.navigation)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              class: _normalizeClass(["swiper-button-prev swiper-no-swiping transition-opacity duration-200", {
                        'opacity-0': _ctx.isBeginning,
                    }]),
              style: _normalizeStyle(_ctx.navStyle)
            }, [
              _createVNode(_component_c_icon, {
                name: "icon-arrow-slider",
                class: "rotate-180 swiper-button-icon",
                "aria-hidden": "true"
              })
            ], 6),
            _createElementVNode("button", {
              class: _normalizeClass(["swiper-button-next swiper-no-swiping transition-opacity duration-200", {
                        'opacity-0': _ctx.isEnd,
                    }]),
              style: _normalizeStyle(_ctx.navStyle)
            }, [
              _createVNode(_component_c_icon, {
                name: "icon-arrow-slider",
                class: "swiper-button-icon",
                "aria-hidden": "true"
              })
            ], 6)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16))
}